
if(!customElements.get('custom-recommended-products')){
    class ProductRecommendations extends HTMLElement { 
        constructor(){
            super();

            this.addEventListener('click', (e) => {
                const link = e.target.closest('a[href*="/products/"]');
                if(!link || !this.contains(link)) return;
                const slide = link.closest('.swiper-slide');
                if(!slide) return;
                const titleEl = slide.querySelector('.heading span');
                const handle = (link.getAttribute('href') || '').split('/products/')[1].split(/[?#]/)[0];
                const index = Array.from(slide.parentElement.children).indexOf(slide);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                    event: 'select_item',
                    ecommerce: {
                        item_list_id: 'recommended',
                        item_list_name: 'こちらもおすすめ',
                        items: [{
                            item_id: decodeURIComponent(handle),
                            item_name: titleEl ? titleEl.textContent.trim() : '',
                            item_list_id: 'recommended',
                            item_list_name: 'こちらもおすすめ',
                            index: index + 1
                        }]
                    }
                });
            });

            const handleIntersection = (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(this);

                fetch(this.dataset.url)
                .then(res => res.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    
                    const recommendations = html.querySelector('custom-recommended-products');

                    if(recommendations && recommendations.innerHTML.trim().length){
                        this.innerHTML = recommendations.innerHTML;
                    }

                    this.swiperContainer = this.querySelector('.swiper-container');

                    this.initSwiper();

                    if(html.querySelector('.swiper-slide')){
                        this.setAttribute('data-loaded',' true');
                    }
                })
                .catch(e=> {
                    console.error(e);
                });
            }

            new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
        }

        initSwiper(){
            if(!this.swiperContainer) return;
            var totalSlides = parseInt(this.swiperContainer.dataset.totalSlides);
            var numPerView = parseInt(this.swiperContainer.dataset.numPerView);
            var slidesPerView = (numPerView && totalSlides > numPerView)? numPerView : totalSlides;
            var loop = false;

            if(totalSlides == 1) return;

            var swiperSettings = {
                init: true,
                initialSlides: 0,
                loop: loop,
                spaceBetween: 30,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                breakpoints: {
                    0: {
                        slidesPerView: slidesPerView < 3? slidesPerView : 3,
                        spaceBetween: 10
                    },
                    567: {
                        slidesPerView: slidesPerView < 2? slidesPerView : 2
                    },
                    991: {
                        slidesPerView: slidesPerView < 3? slidesPerView : 3
                    },
                    1200: {
                        slidesPerView: slidesPerView
                    }
                },
                observer: true,
                observeSlideChildren: true
            }

            if(this.swiperContainer.querySelector('.swiper-pagination')){
                swiperSettings.pagination = {
                  el: this.swiperContainer.querySelector('.swiper-pagination')
                }
            }

            if(this.swiperContainer.querySelector('.swiper-button-next')){
                swiperSettings.navigation = {
                  nextEl: this.swiperContainer.querySelector('.swiper-button-next'),
                  prevEl: this.swiperContainer.querySelector('.swiper-button-prev')
                }
            }

            if(this.swiperContainer.dataset.autoplay == 'true'){
                let speed = this.swiperContainer.dataset.speed;
                speed = parseInt(speed) * 1000;
                swiperSettings.autoplay = {
                    delay: speed
                }
            }

            this.swiper = new Swiper(this.swiperContainer, swiperSettings);

            this.swiper.init();
            this.getVisibleSlides();
            this.checkPagination();

            this.swiper.on('slideChange', () => {
                this.getVisibleSlides();
            });

            this.swiper.on('resize' ,() => {
                this.checkPagination();
            });
        }

        getVisibleSlides(){
            if(this.swiper){
                const allSlides = this.swiper.slides;
                const activeIndex = this.swiper.activeIndex;
                const slidesPerView = this.swiper.params.slidesPerView;

                const visibleSlides = [];
                
                if(slidesPerView === 'auto'){
                    allSlides.forEach((slide) => {
                        const rect = slide.getBoundingClientRect();
                        if (rect.left >= 0 && rect.right <= window.innerWidth) {
                            visibleSlides.push(slide);
                        }
                    });
                }else{
                    for (let i = activeIndex; i < activeIndex + slidesPerView && i < allSlides.length; i++) {
                        visibleSlides.push(allSlides[i]);
                    }
                }
    
                allSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '-1');
                    });
                });
    
                visibleSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '0');
                    });
                });
            }
        }

        checkPagination(){
            var pagination = this.querySelector('.swiper-pagination');
            var btns = {
                prev: this.querySelector('.swiper-button-prev'),
                next: this.querySelector('.swiper-button-next')
            }
            if(pagination && pagination.querySelectorAll('.swiper-pagination-bullet').length <= 1){
                pagination.classList.add('d-none');
                if(btns.prev) btns.prev.style.display = 'none';
                if(btns.next) btns.next.style.display = 'none';
            }else{
                if(pagination) pagination.classList.remove('d-none');
                if(btns.prev) btns.prev.style.display = 'block';
                if(btns.next) btns.next.style.display = 'block';
            }
        }

        refresh(){
            fetch(this.dataset.url)
            .then(res => res.text())
            .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                
                const recommendations = html.querySelector('custom-recommended-products');

                if(recommendations && recommendations.innerHTML.trim().length){
                    this.innerHTML = recommendations.innerHTML;
                }

                this.swiperContainer = this.querySelector('.swiper-container');

                this.initSwiper();

                if(html.querySelector('.swiper-slide')){
                    this.setAttribute('data-loaded',' true');
                }
            })
            .catch(e=> {
                console.error(e);
            })
        }
    }

    customElements.define('custom-recommended-products', ProductRecommendations);
}